import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { BroomIcon } from "@phosphor-icons/react";
import { LDC01_ROUTE, useLdc01Access } from "@/lib/ldc01";

// Rendered inside the Administrator sidebar group. Shown ONLY after the server
// confirms access (GET /admin/ldc01/status → 200). Not part of the RBAC sidebar mirror.
export function Ldc01NavEntry({ collapsed }) {
  const { phase } = useLdc01Access();
  const { pathname } = useLocation();
  if (phase !== "ok") return null;
  const active = pathname.startsWith(LDC01_ROUTE);
  return (
    <div className="mt-2" data-testid="nav-section-controlled-maintenance">
      {!collapsed && (
        <div className="px-3 pt-1 pb-1 text-[10px] uppercase tracking-widest font-semibold text-red-400/80">
          Controlled Maintenance
        </div>
      )}
      <NavLink to={LDC01_ROUTE} data-testid="nav-ldc01-live-data-cleanup"
        title={collapsed ? "Live Data Cleanup" : undefined}
        className={`flex items-center gap-3 ${collapsed ? "justify-center px-2" : "px-3"} py-2 rounded-sm text-sm border border-transparent transition-colors ${
          active ? "bg-[var(--bg-2)] text-white shadow-[inset_2px_0_0_0_#ef4444]" : "text-zinc-300 hover:text-white hover:bg-[var(--bg-2)]/60"}`}>
        <BroomIcon size={15} weight={active ? "fill" : "regular"} className={active ? "text-red-400" : "text-zinc-500"} />
        {!collapsed && <span className="truncate">Live Data Cleanup</span>}
      </NavLink>
    </div>
  );
}
